import { permissions } from "utils/CommonConstants";
import { recommendationAccessTypes } from "utils/Types";

export const getFormatedData = (data: any, newPayload: any) => {
  return [
    {
      label: "User Type",
      key: "userType",
      optionHelperText: true,
      options: [
        { label: "Consultant", value: "Consultant" },
        { label: "Corporate", value: "Corporate" }
      ],
      selected: data?.userType
    },
    ...(newPayload?.userType === "Consultant"
      ? [
          {
            label: permissions.ManageTemplatePlans,
            key: "templatePlansAccess",
            labelHelperText: true,
            options: [
              { label: "Enabled", value: "Enabled" },
              { label: "Disabled", value: "Disabled" }
            ],
            selected: data?.templatePlansAccess
          }
        ]
      : []),
    {
      label: [permissions.PlanPermissions],
      key: "permission",
      labelHelperText: true,
      options: [
        { label: "View", value: "View" },
        { label: "Edit", value: "Edit" },
        { label: "Delete", value: "Delete" },
        { label: "Assign", value: "Assign" }
      ],
      selected: data?.permission
    },
    {
      label: "Manage Feedback",
      key: "manageFeedbackAccess",
      labelHelperText: true,
      options: [
        { label: "Disabled", value: "Disabled" },
        { label: "View", value: "View" },
        { label: "Edit", value: "Edit" }
      ],
      selected: data?.manageFeedbackAccess
    },
    {
      label: "Admin Console",
      key: "adminConsoleAccess",
      labelHelperText: true,
      options: [
        { label: "Enable", value: "Y" },
        { label: "Disable", value: "N" }
      ],
      selected: data?.adminConsoleAccess
    },
    {
      label: "Manage Suggestions",
      key: "uploadRecommendationAccess",
      labelHelperText: true,
      options: [
        { label: "Disable", value: recommendationAccessTypes.disabled },
        { label: "View", value: recommendationAccessTypes.view },
        { label: "Edit", value: recommendationAccessTypes.edit },
        { label: "Upload", value: recommendationAccessTypes.upload }
      ],
      selected: data?.uploadRecommendationAccess
    },
    {
      label: "Manage Metrics",
      key: "uploadMetricAccess",
      labelHelperText: true,
      options: [
        { label: "Disable", value: "Disabled" },
        { label: "Download", value: "Download" },
        { label: "Download and Upload", value: "Upload" }
      ],
      selected: data?.uploadMetricAccess
    }
  ];
};
export const labelFromKey: { [key: string]: string } = {
  userType: "User type",
  adminConsoleAccess: "Admin Console",
  permission: permissions.PlanPermissions,
  uploadRecommendationAccess: "Manage Suggestion",
  manageFeedbackAccess: "Manage Feedback",
  uploadMetricAccess: "Manage Metrics",
  templatePlansAccess: permissions.ManageTemplatePlans
};

export const getInitialState = (data: any) => {
  return {
    userType: data?.userType || "Corporate",
    templatePlansAccess: data?.templatePlansAccess || "Disabled",
    permission: data?.permission || "View",
    adminConsoleAccess: data?.adminConsoleAccess || "N",
    uploadRecommendationAccess: data?.uploadRecommendationAccess || recommendationAccessTypes.disabled,
    manageFeedbackAccess: data?.manageFeedbackAccess || "Disabled",
    uploadMetricAccess: data?.uploadMetricAccess || "Disabled"
  };
};
